//@flow
import {
  EyeType,
  PointType,
  FaceDetectionResultType,
  EnrolmentType
} from "../../global/types/FaceType";

export type EnrolmentInputModel = {
  enrolmentId: string,
  imgUrl: string,
  token: string,
  eyes: EyeType,
  nose: PointType,
  mouth: EyeType,
  size: number
};

export type PersonInputModel = {
  name: string,
  tags: string[],
  details: { [name: string]: string }[],
  newEnrolments: EnrolmentInputModel[],
  deleteEnrolments: string[],
  currentEnrolments: EnrolmentType[],
  uuid: string
};

export const initialPersonInput: PersonInputModel = {
  name: "",
  tags: [],
  details: [],
  newEnrolments: [],
  deleteEnrolments: [],
  currentEnrolments: []
};

export type ImageSearchInputModel = {
  eyes: EyeType,
  unique?: boolean,
  tagAnd?: boolean,
  displayTags?: boolean,
  includeTags: string[],
  excludeTag: string[],
  maxResult?: number
};
